import { DarkTheme, ThemeProvider } from "@react-navigation/native";
import { Stack } from "expo-router";
import Head from "expo-router/head";
import { Platform } from "react-native";

import "@/atoms/events";
import "@/atoms/profile";
import { useSessionSync } from "@/atoms/session";
import StripeProvider from "@/components/stripe-provider";
import { colors } from "@/constants/colors";
import { BugsnagErrorBoundary } from "@/lib/bugsnag";

const WebDarkTheme = {
  ...DarkTheme,
  colors: {
    ...DarkTheme.colors,
    background: colors.transparent,
    card: colors.transparent,
  },
};

export default function RootLayout() {
  useSessionSync();
  const isWeb = Platform.OS === "web";

  const darkTheme = isWeb ? WebDarkTheme : DarkTheme;

  return (
    <BugsnagErrorBoundary>
      <StripeProvider>
        <Head>
          <title>Aglow</title>
          <meta content="connection > consumption" name="description" />
          <meta content="Aglow" property="og:title" />
          <meta content="more social, less media" property="og:description" />
          <meta
            content="https://aglow.life/assets/icon.gif"
            property="og:image"
          />
          <meta content="website" property="og:type" />
          <meta content="player" name="twitter:card" />
          <meta content="Aglow" name="twitter:title" />
          <meta content="more social, less media" name="twitter:description" />
          <meta
            content="https://aglow.life/assets/icon.gif"
            name="twitter:image"
          />
        </Head>
        <ThemeProvider value={darkTheme}>
          <Stack
            screenOptions={
              isWeb ? { contentStyle: { backgroundColor: "transparent" } } : {}
            }
          >
            <Stack.Screen name="index" options={{ headerShown: false }} />
            <Stack.Screen name="privacy" options={{ headerShown: false }} />
            <Stack.Screen name="terms" options={{ headerShown: false }} />
            <Stack.Screen name="e/index" options={{ headerShown: false }} />
            <Stack.Screen name="e/[slug]" options={{ headerShown: false }} />
          </Stack>
        </ThemeProvider>
      </StripeProvider>
    </BugsnagErrorBoundary>
  );
}
